const listDefaults = {
  data () {
    return {
      first: true,
      selected: { ...this.default }
    }
  },

  watch: {
    data: {
      deep: true,
      handler () {
        if (this.first) this.initialize()
        this.first = false
      }
    }
    /* '$route' () {
      this.initialize()
    } */
  },

  methods: {
    initialize () {
      if ((this.routerPath && this.routerPath.page === this.pageName) && parseInt(this.routerPath.id) > 0) {
        const item = (typeof this.data !== 'undefined' && this.data ? this.data.find(element => element.id === parseInt(this.routerPath.id)) : false)
        if (item) {
          switch (this.routerPath.action) {
            case 'edit':
              this.editPage(item)
              break
          }
        } else {
          this.$store.dispatch('snackBar', { type: 1, message: this.lang[this.routerPath.page].messages.error.not_found })
        }
      } else {
        this.resetPage()
      }
    },

    editPage (item) {
      /* const item_ = Object.entries(item)
      const item__ = {}
      item_.forEach((value_, key_) => {
        key_ = value_[0]
        value_ = value_[1]
        const blank_ = []
        item__[key_] = (value_ && value_.constructor.name === 'Array' ? blank_.concat(value_) : value_)
      })
      this.selected = { ...Object.assign({}, item__) } */
      this.selected = Object.assign({}, { ...item })
      this.$router.push({
        name: `${this.routerPath.root}${(this.routerPath.page && this.routerPath.page !== 'default' ? ':' + this.routerPath.type : '')}:edit`,
        params: {
          id: item.id,
          page: (this.routerPath.page ? this.routerPath.page_path : false)
        }
      }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
    },

    resetPage () {
      this.selected = { ...this.default }
      if (this.$refs.SaveForm) this.$refs.SaveForm.resetValidation()
      this.$router.push({ name: `${this.routerPath.root}${(this.routerPath.page && this.routerPath.page !== 'default' ? ':' + this.routerPath.type : '')}`, params: { page: (this.routerPath.page ? this.routerPath.page_path : false) } }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
    },

    onCloseView (val) {
      if (val) this.$router.push({ name: `${this.routerPath.root}${(this.routerPath.page && this.routerPath.page !== 'default' ? ':' + this.routerPath.type : '')}`, params: { page: (this.routerPath.page ? this.routerPath.page_path : false) } }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
    },

    onCloseSave (val) {
      if (val) this.$router.push({ name: `${this.routerPath.root}${(this.routerPath.page && this.routerPath.page !== 'default' ? ':' + this.routerPath.type : '')}`, params: { page: (this.routerPath.page ? this.routerPath.page_path : false) } }).catch(err => { if (err.name !== 'NavigationDuplicated') console.error(err) })
    }
  },

  created () {
    // Listener popstate para evitar vazamento de memória
    this._onPopState = () => {
      this.initialize()
    }
    window.addEventListener('popstate', this._onPopState)
    // Inicialização original
    if (typeof this.initialize === 'function') {
      this.initialize()
    }
  },

  mounted () {
    this.resetPage()
  },

  destroyed () {
    window.removeEventListener('popstate', this._onPopState)
    this._onPopState = null
  }
}

export default listDefaults
